module.exports = __webpack_public_path__ + "344b7543b5460746117587baaca867fa.MP3";